import { isClassicMetricVisible } from './classicMetricsDefaults';
import { isJudgeMetricEnabled } from './llmJudgeConfigUtils';

const NON_METRIC_ROW_KEYS = new Set([
  'id',
  'sample_text',
  'original_source_text',
  'teacher_summary',
  'student_summary',
  'reference_summary',
  'language',
  'BLEU',
]);

export const ALL_BUILTIN_JUDGE_KEYS = new Set([
  'factuality',
  'completeness',
  'conciseness',
  'coherence',
  'compression',
]);

export function isFiniteMetricValue(value) {
  if (value === null || value === undefined || value === '') return false;
  if (typeof value === 'string' && value.trim() === '') return false;
  const n = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(n);
}

export function rowHasNumericMetric(rows, key) {
  return (rows || []).some((row) => isFiniteMetricValue(row?.[key]));
}

/**
 * Columns for the Evaluations Samples table.
 *
 * Overview already hides disabled LLM-as-a-judge criteria and metrics with no
 * numeric values. The Samples table used to inject every hardcoded judge and
 * classic key, so content-generation rows showed Completeness / Conciseness /
 * Compression Ratio as 0% even when those fields were null.
 */
export function buildSampleTableMetricColumns({
  rows,
  judgeItems,
  classicItems,
  enabledById,
  classicConfig,
}) {
  const visibleJudgeItems = (judgeItems || []).filter(
    (item) => isJudgeMetricEnabled(item.key, enabledById) && rowHasNumericMetric(rows, item.key),
  );
  const visibleClassicItems = (classicItems || []).filter((item) => (
    rowHasNumericMetric(rows, item.key)
  ));

  const judgeKeys = new Set(visibleJudgeItems.map((item) => item.key));
  const classicKeys = new Set(visibleClassicItems.map((item) => item.key));
  const customKeys = [];
  const seen = new Set();

  (rows || []).forEach((row) => {
    if (!row || typeof row !== 'object') return;
    Object.keys(row).forEach((key) => {
      if (seen.has(key) || NON_METRIC_ROW_KEYS.has(key)) return;
      if (!isClassicMetricVisible(key, classicConfig)) return;
      if (!rowHasNumericMetric(rows, key)) return;
      if (judgeKeys.has(key) || classicKeys.has(key)) return;
      if (ALL_BUILTIN_JUDGE_KEYS.has(String(key).toLowerCase())) return;
      seen.add(key);
      customKeys.push(key);
    });
  });
  customKeys.sort((a, b) => a.localeCompare(b));

  return {
    judgeItems: visibleJudgeItems,
    classicItems: visibleClassicItems,
    customKeys,
    allMetricKeys: [
      ...customKeys,
      ...visibleJudgeItems.map((item) => item.key),
      ...visibleClassicItems.map((item) => item.key),
    ],
  };
}
